import { useMemo } from "react";
import { AgGridReact } from "@jsq/ds/core";
import { DashboardCell } from "~/pages/Dashboard/components/WorkspaceTable/CellComponents";

export const useWorkspaceRolesTable = () => {
  const columnDefs: AgGridReact.AgGridReactProps["columnDefs"] = useMemo(() => {
    return [
      {
        field: "role",
        headerName: "Role",
        cellRenderer: DashboardCell,
        filter: "agTextColumnFilter",
      },
      {
        field: "assignedUsers",
        filter: "agNumberColumnFilter",
        headerName: "Assigned users",
        cellRenderer: DashboardCell,
      },
    ];
  }, []);

  return { columnDefs };
};
